var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#4D7EFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0729 8.44792L11.5521 8.92708L6.83333 13.6458H6.35417V13.1667L11.0729 8.44792ZM12.9479 5.3125C12.8177 5.3125 12.6823 5.36458 12.5833 5.46354L11.6302 6.41667L13.5833 8.36979L14.5365 7.41667C14.7396 7.21354 14.7396 6.88542 14.5365 6.68229L13.3177 5.46354C13.2135 5.35937 13.0833 5.3125 12.9479 5.3125ZM11.0729 6.97396L5.3125 12.7344V14.6875H7.26562L13.026 8.92708L11.0729 6.97396Z",
    fill: "#4D7EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailEdit);
export default __webpack_public_path__ + "static/media/email-edit.fd741d37a83b088166bbf27e6e850135.svg";
export { ForwardRef as ReactComponent };